import express, { Router } from 'express';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { generateR2PresignedUrl } from '@/shared/core/R2/R2.controller';

const router: Router = express.Router();

// gernerate s3 presigned url
router
  .route('/:folderName')
  .post(userAuthAndCheckPermissions(), generateR2PresignedUrl);

export default router;
